import { computeEntityTimestamps } from '@app/styles/frontend/utils/entity-timestamps';
import { ModuleFE_Pathway, ModuleFE_PathwayState, ModuleFE_PathwayTransition } from '../_entity.js';
/**
 * created = pathway.__created
 * lastEdited = max(__updated) across the pathway, its states and its transitions.
 * Orders / order-groups are intentionally excluded: they are shared entities referenced by
 * multiple pathways, so their edits should not count as edits of this pathway.
 */
export const getPathwayTimestamps = (pathwayId) => {
    const pathway = ModuleFE_Pathway.cache.unique(pathwayId);
    if (!pathway)
        return undefined;
    const states = ModuleFE_PathwayState.cache.filter(s => s.pathwayIds.includes(pathwayId));
    const transitions = ModuleFE_PathwayTransition.cache.filter(t => t.pathwayIds.includes(pathwayId));
    return computeEntityTimestamps(pathway, states, transitions);
};
//# sourceMappingURL=pathway-timestamps.js.map